<div class="user-panel">
  <div class="filter-wrapper">
    <div class="filter-content">
      <div class="filter-header">
        <h6>{{ 'Filters' | translate }}</h6>
      </div>
      <div class="row">
        @for (filter of filters; track $index) {
          <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12">
            @if ((isMinimized && $index < minimizedCount) || (!isMinimized)) {
              @if (filter.Type === FilterType.CHECK_BOX) {
                <div class="filter-input-wrapper">
                  <app-frontend-check-box [(value)]="filter.Value"
                                          [title]="filter.Title"></app-frontend-check-box>
                </div>
              }
              @if (filter.Type === FilterType.DATE) {
                <div class="filter-input-wrapper">
                  <app-frontend-date [(value)]="filter.Value"
                                     [required]="filter.Required"
                                     [title]="filter.Title"></app-frontend-date>
                </div>
              }
              @if (filter.Type === FilterType.DROP_DOWN) {
                <div class="filter-input-wrapper">
                  <app-frontend-dropdown (onSelected)="onItemSelected($index, $event)"
                                         [(value)]="filter.Value"
                                         [autoSelectLatest]="filter.AutoSelectLatest"
                                         [displayKey]="filter.DisplayKey"
                                         [fieldName]="filter.FieldName"
                                         [isMultiple]="filter.IsMultiple"
                                         [isSearchable]="filter.IsSearchable"
                                         [options]="filter.Options"
                                         [required]="filter.Required"
                                         [searchOnKey]="filter.SearchOnKey"
                                         [selectedOptions]="filter.SelectedOptions"
                                         [title]="filter.Title"></app-frontend-dropdown>
                </div>
              }
              @if (filter.Type === FilterType.STRING) {
                <div class="filter-input-wrapper">
                  <app-frontend-input [(value)]="filter.Value"
                                      [lookup]="filter.Lookup"
                                      [required]="filter.Required"
                                      [title]="filter.Title"
                                      [type]="'text'"
                                      class="input-filter"></app-frontend-input>
                </div>
              }
              @if (filter.Type === FilterType.TIME) {
                <div class="filter-input-wrapper">
                  <app-frontend-input [(value)]="filter.Value"
                                      [lookup]="filter.Lookup"
                                      [required]="filter.Required"
                                      [title]="filter.Title"
                                      [type]="'time'"
                                      class="input-filter"></app-frontend-input>
                </div>
              }
              @if (filter.Type === FilterType.NUMBER) {
                <div class="filter-input-wrapper">
                  <app-frontend-input [(value)]="filter.Value"
                                      [required]="filter.Required"
                                      [title]="filter.Title"
                                      [type]="'number'"
                                      class="input-filter"></app-frontend-input>
                </div>
              }
              @if (filter.Type === FilterType.SELECT) {
                <div class="filter-input-wrapper">
                  <app-frontend-select (onSelected)="onItemSelected($index, $event)"
                                       [autoSelectLatest]="filter.AutoSelectLatest"
                                       [controller]="filter.Controller"
                                       [displayKey]="filter.DisplayKey"
                                       [fieldName]="filter.FieldName"
                                       [isMultiple]="filter.IsMultiple"
                                       [isSearchable]="filter.IsSearchable"
                                       [method]="filter.Method"
                                       [microservice]="filter.Microservice"
                                       [orderByField]="filter.OrderByField"
                                       [orderByType]="filter.OrderByType"
                                       [protocolMethod]="filter.ProtocolMethod"
                                       [required]="filter.Required"
                                       [searchOnKey]="filter.SearchOnKey"
                                       [selectedOptions]="filter.SelectedOptions"
                                       [title]="filter.Title"
                                       [version]="filter.Version"></app-frontend-select>
                </div>
              }
            }
          </div>
        }
      </div>
    </div>

    @if (minimizedCount < filters.length) {
      <div class="d-flex justify-content-center my-2">
        @if (isMinimized) {
          <label (click)="isMinimized = !isMinimized"
                 class="moreSearch cursor-pointer d-flex align-items-center">
            {{ 'MoreSearch' | translate }}
            <mat-icon class="moreSearch">arrow_drop_down</mat-icon>
          </label>
        } @else {
          <label (click)="isMinimized = !isMinimized"
                 class="moreSearch cursor-pointer d-flex align-items-center">
            {{ 'LessSearch' | translate }}
            <mat-icon>arrow_drop_up</mat-icon>
          </label>
        }
      </div>
    }
    @if (filters && filters.length !== 0) {
      <div class="btn-filter flex-wrap">
        <app-frontend-button (click)="onSearchClicked()"
                             [Image]="true"
                             [class]="'card-green'"
                             [disabled]="false"
                             [src]="'icons/search-normal.svg'"
                             [title]="'Search'">
        </app-frontend-button>
        <app-frontend-button (click)="onResetClicked()"
                             [Image]="true"
                             [class]="'card-yellow'"
                             [disabled]="false"
                             [src]="'icons/refresh-2.svg'"
                             [title]="'Reset'">
        </app-frontend-button>
      </div>
    }
    @if (lookupName) {
      <div>
        <div>
          <app-frontend-table [dataSource]="dataSource"
                              [displayColumnTypes]="displayColumnTypes"
                              [displayColumns]="displayColumns"
                              [displayDataSources]="displayDataSources"
                              [tableProperties]="tableProperties">
          </app-frontend-table>
        </div>
      </div>
    }
  </div>
</div>
